import React from "react";
import ReturnForm from "../components/ReturnForm";

export default function ReturnDetail() {
  return <ReturnForm mode="edit" />;
}
